import { CanvasComment } from 'src/app/shared/models/domain/canvas-comment';


export class CanvasCommentUtil {
    private static instance: CanvasCommentUtil;

    static getInstance() {
        if (!CanvasCommentUtil.instance) {
            CanvasCommentUtil.instance = new CanvasCommentUtil();
        }

        return CanvasCommentUtil.instance;
    }

    /**
    * CanvasCommentUtil is a singleton class, so use CanvasCommentUtil.getInstance() method instead of creating new CanvasCommentUtil().
    */
    private constructor() {

    }

    copy(canvasCommentsTmp: Array<CanvasComment>): Array<CanvasComment> {
        let canvasComment: Array<CanvasComment> = new Array<CanvasComment>();

        for (let i: number = 0; i < canvasCommentsTmp.length; i++) {
            let transform: CanvasComment = CanvasComment.parse(canvasCommentsTmp[i]);
            if (!transform) continue;

            canvasComment.push(transform);
        }

        return canvasCommentsTmp;
    }

    copyFrom(canvasComments: Array<CanvasComment>, canvasCommentsTmp: Array<CanvasComment>): void {
        let canvasCommentsMap: Map<number, CanvasComment> = new Map<number, CanvasComment>();

        for (let i: number = 0; i < canvasComments.length; i++) {
            let canvasComment: CanvasComment = canvasComments[i];
            canvasCommentsMap.set(canvasComment.comment_Inst.comment_Inst_Id, canvasComment);
        }

        canvasComments.splice(0, canvasComments.length);

        for (let i: number = 0; i < canvasCommentsTmp.length; i++) {
            let canvasCommentTmp: CanvasComment = canvasCommentsTmp[i];
            let canvasComment: CanvasComment = canvasCommentsMap.get(canvasCommentTmp.comment_Inst.comment_Inst_Id);
            if (canvasComment) {
                canvasComment.copyFrom(canvasCommentTmp);
            } else {
                canvasComment = CanvasComment.parse(canvasCommentTmp)
            }

            canvasComments.push(canvasComment);
        }
    }
}